// extracted by mini-css-extract-plugin
module.exports = {"image":"style_image__zol4b","image-gallery":"style_image-gallery__32y3h","image-gallery-slide":"style_image-gallery-slide__YZ2dc","fullscreen":"style_fullscreen__1agz2"};